
import React, { useState, useEffect } from "react";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import {
  doc,
  addDoc,
  setDoc,
  collection,
  getDocs,
  query,
  where,
  getDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../components/firebase-config.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faCalendarPlus,
  faSave,
  faTimes,
  faCheck,
  faClinicMedical,
  faUser,
  faCalendarAlt,
  faFilter,
  faEdit,
  faTrash,
  faEye,
  faLock,
  faUnlock,
  faHistory,
  faBuilding,
  faChevronLeft,
  faChevronRight,
  faCalendarDay,
  faCalendarWeek,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faArrowDownRightFromSquare,
  faArrowUpLeftFromSquare,
  faArrowDownLeftFromSquare,
  faArrowUpShortWide,
  faArrowDownShortWide,
  faArrowUpLong,
  faArrowDownLong,
  faInfo,
  faExclamationTriangle,
  faPhone,
  faEnvelope,
  faArrowUpZA,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

import { initializeApp } from "firebase/app";

const MedecinPatientManager = () => {
  // États pour les données
  const [medecinData, setMedecinData] = useState(null);
  const [affiliatedStructures, setAffiliatedStructures] = useState([]);
  const [patients, setPatients] = useState([]);
  const [rendezVous, setRendezVous] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  // États pour les formulaires
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [showRendezvousForm, setShowRendezvousForm] = useState(false);
  const [showEditPatientForm, setShowEditPatientForm] = useState(false);
  const [activeTab, setActiveTab] = useState("patients");
  const [patientSubTab, setPatientSubTab] = useState("list"); // Pour la navigation dans l'onglet patients

  // États pour le calendrier
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState("week"); // 'day', 'week', 'month'
  const [selectedRdv, setSelectedRdv] = useState(null);
  const [showEditRdvForm, setShowEditRdvForm] = useState(false);
  const [rdvEditForm, setRdvEditForm] = useState({
    patientId: "",
    date: "",
    heure: "",
    duree: 30,
    motif: "",
    statut: "confirmé",
    structureId: "",
    isPrivate: false,
  });

  // État pour le filtrage
  const [filterPrivate, setFilterPrivate] = useState(false);
  const [filterStructure, setFilterStructure] = useState("");
  const [filterHasAppointment, setFilterHasAppointment] = useState(false);
  const [filterPrivateRdv, setFilterPrivateRdv] = useState(false); // Filtre pour les RDV privés
  const [filterStructurePatients, setFilterStructurePatients] = useState(false); // Filtre pour les patients de la structure
  const [filterCalendarDate, setFilterCalendarDate] = useState(new Date()); // Date pour le filtre du calendrier
  const [filterCalendarStructure, setFilterCalendarStructure] = useState(""); // Structure pour le filtre du calendrier
  // État pour le popup d'iframe
  const [showWebPopup, setShowWebPopup] = useState(false);
  const [webPopupUrl, setWebPopupUrl] = useState("");
  const [webPopupTitle, setWebPopupTitle] = useState("");
  // Fonction pour ouvrir le popup avec une page web
  const openWebPopup = (url, title = "Page Web") => {
    setWebPopupUrl(url);
    setWebPopupTitle(title);
    setShowWebPopup(true);
  };

  // État pour le patient sélectionné pour modification
  const [selectedPatient, setSelectedPatient] = useState(null);

  // État pour le formulaire patient
  const [patientForm, setPatientForm] = useState({
    nom: "",
    prenom: "",
    dateNaissance: "",
    email: "",
    telephone: "",
    sexe: "",
    adresse: "",
    assurances: [],
    numeroAssurance: "",
    antecedentsMedicaux: "",
    structureId: "", // Structure pour laquelle le patient est créé
    isPrivate: false, // Nouveau champ pour indiquer si le patient est privé
  });

  // État pour le formulaire rendez-vous
  const [rdvForm, setRdvForm] = useState({
    patientId: "",
    date: new Date().toISOString().split("T")[0],
    heure: "08:00",
    duree: 30,
    motif: "",
    statut: "confirmé",
    structureId: "", // Structure pour laquelle le RDV est créé
    isPrivate: false, // Nouveau champ pour indiquer si le RDV est privé
  });

  // État pour stocker les informations de connexion du médecin
  const [medecinAuth, setMedecinAuth] = useState({
    email: "",
    uid: "",
  });

  // Liste des assurances disponibles
  const assurancesList = [
    "CNAM",
    "CNSS",
    "CNRPS",
    "Assurance privée",
    "Autre",
    "Sanlam",
    "AXA",
    "NSIA",
    "Saham Assurance",
    "Leadway Assurance",
    "Mutuelle des Fonctionnaires",
    "SONAM",
    "Allianz",
    "Liberty Mutual",
    "Activa Assurance",
    "SUNU Assurances",
    "GA Insurance",
    "MUA Insurance",
    "Fidelity Insurance",
    "Old Mutual",
    "Hollard Insurance",
    "Ecobank Assurances",
    "Prudential",
    "Afric Assistance",
    "ASKIA Assurances",
    "BICIS Assurances",
    "UGB Assurance",
    "AMO Assurance",
  ];

  // Configuration pour l'API Maytapi (WhatsApp)
  const MAYTAPI_PRODUCT_ID = "5e994f76-4f49-4057-aca4-6bef3b1de795"; // À remplacer par votre Product ID
  const MAYTAPI_API_TOKEN = "a0b5ba45-b4da-429e-ba5b-127851d9b92e"; // À remplacer par votre token API
  const MAYTAPI_PHONE_ID = "85860"; // À remplacer par votre Phone ID

  const auth = getAuth();

  const firebaseConfig = {
    apiKey: "AIzaSyDrjQG3Be61p03uDG-vjP9zoIcEVI-fyQk",
    authDomain: "app1base-8a8ac.firebaseapp.com",
    databaseURL: "https://app1base-8a8ac-default-rtdb.firebaseio.com",
    projectId: "app1base-8a8ac",
    storageBucket: "app1base-8a8ac.firebasestorage.app",
    messagingSenderId: "791621171816",
    appId: "1:791621171816:web:b13bd9d060ed7c26ee19dd",
    measurementId: "G-8QRRB40X9R",
  };

  // Initialiser une application Firebase séparée pour l'authentification des patients
  const patientApp = initializeApp(firebaseConfig, "patientApp");
  const patientAuth = getAuth(patientApp);

  // Fonction pour recharger la liste des patients
  const reloadPatients = async () => {
    try {
      const user = auth.currentUser;
      if (!user) {
        console.log("Pas d'utilisateur connecté pour charger les patients");
        return;
      }

      console.log("Chargement des patients pour le médecin:", user.uid);

      // 1. Récupérer les patients créés par le médecin
      const medecinPatientsQuery = query(
        collection(db, "patients"),
        where("createdBy", "==", user.uid)
      );

      const medecinPatientsSnapshot = await getDocs(medecinPatientsQuery);
      const medecinPatientsData = [];
      medecinPatientsSnapshot.forEach((doc) => {
        medecinPatientsData.push({
          id: doc.id,
          ...doc.data(),
          createdByMedecin: true, // Marquer comme créé par ce médecin
        });
      });

      // 2. Récupérer les patients des structures affiliées
      const structurePatientsData = [];
      for (const structure of affiliatedStructures) {
        const structurePatientsQuery = query(
          collection(db, "patients"),
          where("structureId", "==", structure.id),
          where("createdBy", "!=", user.uid) // Exclure les patients déjà récupérés
        );

        const structurePatientsSnapshot = await getDocs(structurePatientsQuery);
        structurePatientsSnapshot.forEach((doc) => {
          structurePatientsData.push({
            id: doc.id,
            ...doc.data(),
            createdByStructure: true, // Marquer comme créé par une structure
            structureName: structure.nom,
          });
        });
      }

      // 3. Récupérer les patients qui ont des rendez-vous avec ce médecin
      // mais qui n'ont pas été créés par lui et qui n'appartiennent pas à ses structures
      const rdvPatientsIds = new Set();

      // Obtenir tous les IDs de patients ayant des rendez-vous avec ce médecin
      rendezVous.forEach((rdv) => {
        if (rdv.medecinId === user.uid && rdv.patientId) {
          rdvPatientsIds.add(rdv.patientId);
        }
      });

      // Filtrer pour ne garder que les IDs qui ne sont pas déjà dans nos listes
      const existingPatientIds = new Set([
        ...medecinPatientsData.map((p) => p.id),
        ...structurePatientsData.map((p) => p.id),
      ]);

      const missingPatientIds = [...rdvPatientsIds].filter(
        (id) => !existingPatientIds.has(id)
      );

      // Récupérer les données de ces patients manquants
      const rdvPatientsData = [];
      for (const patientId of missingPatientIds) {
        try {
          const patientDoc = await getDoc(doc(db, "patients", patientId));
          if (patientDoc.exists()) {
            rdvPatientsData.push({
              id: patientId,
              ...patientDoc.data(),
              fromRdv: true, // Marquer comme venant d'un rendez-vous
            });
          }
        } catch (error) {
          console.error(
            `Erreur lors de la récupération du patient ${patientId}:`,
            error
          );
        }
      }

      // Combiner les trois listes
      const allPatients = [
        ...medecinPatientsData,
        ...structurePatientsData,
        ...rdvPatientsData,
      ];
      console.log("Patients chargés:", allPatients.length);
      setPatients(allPatients);
    } catch (error) {
      console.error("Erreur lors du chargement des patients:", error);
    }
  };

  // Fonction pour charger les rendez-vous
  const loadRendezVous = async () => {
    try {
      const user = auth.currentUser;
      if (!user) {
        console.log("Pas d'utilisateur connecté pour charger les rendez-vous");
        return;
      }

      console.log("Chargement des rendez-vous pour le médecin:", user.uid);
      const rdvQuery = query(
        collection(db, "rendezvous"),
        where("medecinId", "==", user.uid)
      );

      const rdvSnapshot = await getDocs(rdvQuery);
      const rdvData = [];
      rdvSnapshot.forEach((doc) => {
        rdvData.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      console.log("Rendez-vous chargés:", rdvData.length);
      setRendezVous(rdvData);
    } catch (error) {
      console.error("Erreur lors du chargement des rendez-vous:", error);
    }
  };

  // Récupération des données du médecin et des structures affiliées
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          console.log("Pas d'utilisateur connecté");
          setLoading(false);
          return;
        }

        console.log("Utilisateur connecté:", user.uid);

        // Stocker l'email et l'ID du médecin pour la reconnexion ultérieure si nécessaire
        setMedecinAuth({
          email: user.email,
          uid: user.uid,
        });

        // Récupérer les données du médecin
        const medecinDoc = await getDoc(doc(db, "medecins", user.uid));
        if (medecinDoc.exists()) {
          setMedecinData(medecinDoc.data());
        } else {
          console.log("Document médecin non trouvé");
        }

        // Récupérer les structures affiliées
        const affiliationsQuery = query(
          collection(db, "affiliationRequests"),
          where("medecinId", "==", user.uid),
          where("status", "==", "accepted")
        );

        const querySnapshot = await getDocs(affiliationsQuery);
        const structureIds = [];
        querySnapshot.forEach((doc) => {
          structureIds.push(doc.data().structureId);
        });

        // Récupérer les détails des structures
        const structures = [];
        for (const structureId of structureIds) {
          const structureDoc = await getDoc(doc(db, "structures", structureId));
          if (structureDoc.exists()) {
            structures.push({
              id: structureId,
              ...structureDoc.data(),
            });
          }
        }

        setAffiliatedStructures(structures);

        // Charger les rendez-vous
        await loadRendezVous();
        // Charger les patients
        await reloadPatients();
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
        setMessage(`Erreur: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [auth]);

  // Fonction pour générer un mot de passe aléatoire
  const generateRandomPassword = (length = 6) => {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    let password = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }

    return password;
  };

  // Fonction pour envoyer un message WhatsApp via Maytapi
  const sendWhatsAppMessage = async (phoneNumber, message) => {
    try {
      // Simuler l'envoi du message pour le développement
      console.log(`Envoi de message WhatsApp à ${phoneNumber}: ${message}`);

      const response = await axios({
        method: "post",
        url: `https://api.maytapi.com/api/${MAYTAPI_PRODUCT_ID}/${MAYTAPI_PHONE_ID}/sendMessage`,
        headers: {
          "Content-Type": "application/json",
          "x-maytapi-key": MAYTAPI_API_TOKEN,
        },
        data: {
          to_number: phoneNumber,
          message: message,
          type: "text",
        },
      });

      console.log("Message WhatsApp envoyé avec succès:", response.data);
      return response.data;

      return { success: true };
    } catch (error) {
      console.error("Erreur lors de l'envoi du message WhatsApp:", error);
      throw error;
    }
  };

  // Fonction pour formater un numéro de téléphone au format international
  const formatPhoneNumberForWhatsApp = (phoneNumber, countryCode = "221") => {
    // Supprimer les espaces, tirets et autres caractères non numériques
    let cleaned = phoneNumber.replace(/\D/g, "");

    // Si le numéro commence par un 0, le remplacer par le code pays
    if (cleaned.startsWith("0")) {
      cleaned = "+" + countryCode + cleaned.substring(1);
    }
    // Si le numéro ne commence pas par un +, ajouter le +
    else if (!cleaned.startsWith("+")) {
      cleaned = "+" + countryCode + cleaned;
    }

    return cleaned;
  };

  // Fonction pour réinitialiser le formulaire patient
  const resetPatientForm = () => {
    setPatientForm({
      nom: "",
      prenom: "",
      dateNaissance: "",
      email: "",
      telephone: "",
      sexe: "",
      adresse: "",
      assurances: [],
      numeroAssurance: "",
      antecedentsMedicaux: "",
      structureId: "",
      isPrivate: false,
    });
  };

  // Fonction pour réinitialiser le formulaire rendez-vous
  const resetRdvForm = () => {
    setRdvForm({
      patientId: "",
      date: new Date().toISOString().split("T")[0],
      heure: "08:00",
      duree: 30,
      motif: "",
      statut: "confirmé",
      structureId: "",
      isPrivate: false,
    });
  };

  // Fonction pour réinitialiser le formulaire d'édition de rendez-vous
  const resetRdvEditForm = () => {
    setRdvEditForm({
      patientId: "",
      date: "",
      heure: "",
      duree: 30,
      motif: "",
      statut: "confirmé",
      structureId: "",
      isPrivate: false,
    });
    setSelectedRdv(null);
  };

  // Gestion du changement dans le formulaire patient
  const handlePatientChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...patientForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setPatientForm({ ...patientForm, [name]: updatedArray });
    } else if (type === "checkbox") {
      // Pour les autres checkboxes (comme isPrivate)
      setPatientForm({ ...patientForm, [name]: checked });
    } else {
      setPatientForm({ ...patientForm, [name]: value });
    }
  };

  // Gestion du changement dans le formulaire rendez-vous
  const handleRdvChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setRdvForm({ ...rdvForm, [name]: checked });
    } else {
      setRdvForm({ ...rdvForm, [name]: value });

      // Si le patient est sélectionné, mettre à jour la structure et le statut privé
      if (name === "patientId" && value) {
        const selectedPatient = patients.find((p) => p.id === value);
        if (selectedPatient) {
          // Si le patient est créé par une structure, le rendez-vous doit être associé à cette structure
          if (selectedPatient.createdByStructure) {
            setRdvForm((prev) => ({
              ...prev,
              structureId: selectedPatient.structureId,
              isPrivate: false,
            }));
          }
        }
      }
    }
  };

  // Gestion du changement dans le formulaire d'édition de rendez-vous
  const handleRdvEditChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setRdvEditForm({ ...rdvEditForm, [name]: checked });
    } else {
      setRdvEditForm({ ...rdvEditForm, [name]: value });

      // Si le patient est sélectionné, mettre à jour la structure et le statut privé
      if (name === "patientId" && value) {
        const selectedPatient = patients.find((p) => p.id === value);
        if (selectedPatient) {
          // Si le patient est créé par une structure, le rendez-vous doit être associé à cette structure
          if (selectedPatient.createdByStructure) {
            setRdvEditForm((prev) => ({
              ...prev,
              structureId: selectedPatient.structureId,
              isPrivate: false,
            }));
          }
        }
      }
    }
  };

  // Fonction pour ajouter un patient
  const handleAddPatient = async (e) => {
    e.preventDefault();

    // Si le patient est privé, pas besoin de structure
    if (!patientForm.isPrivate && !patientForm.structureId) {
      setMessage(
        "Veuillez sélectionner une structure ou marquer le patient comme privé"
      );
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;

      if (!user) {
        setMessage("Vous n'êtes pas connecté. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      // Sauvegarder l'ID du médecin actuel
      const currentMedecinUid = user.uid;
      console.log("Médecin actuel:", currentMedecinUid);

      // Générer un mot de passe aléatoire pour le nouveau patient
      const generatedPassword = generateRandomPassword(6);

      // Données du patient à enregistrer
      const patientData = {
        ...patientForm,
        createdBy: currentMedecinUid,
        createdAt: new Date(),
        updatedAt: new Date(),
        role: "patient", // Ajouter explicitement le rôle
        isPrivate: patientForm.isPrivate, // S'assurer que le champ isPrivate est inclus
        createdByMedecin: true, // Marquer comme créé par ce médecin
      };

      console.log("Création du compte patient avec email:", patientForm.email);

      // Créer un compte utilisateur avec le mot de passe généré en utilisant l'instance d'authentification séparée
      const userCredential = await createUserWithEmailAndPassword(
        patientAuth,
        patientForm.email,
        generatedPassword
      );

      const patientAuthId = userCredential.user.uid;
      console.log("Patient créé avec ID:", patientAuthId);

      // Utiliser l'ID d'authentification comme ID du document patient
      await setDoc(doc(db, "patients", patientAuthId), patientData);
      console.log("Document patient créé dans Firestore");

      // Formater le numéro de téléphone pour WhatsApp
      let phoneNumber = formatPhoneNumberForWhatsApp(patientForm.telephone);

      // Préparer le message de bienvenue
      const welcomeMessage =
        `Bonjour ${patientForm.prenom} ${patientForm.nom},\n\n` +
        `Bienvenue sur notre plateforme de gestion médicale!\n\n` +
        `Voici vos informations de connexion:\n` +
        `Email: ${patientForm.email}\n` +
        `Mot de passe: ${generatedPassword}\n\n` +
        `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;

      // Envoyer le message WhatsApp
      await sendWhatsAppMessage(phoneNumber, welcomeMessage);

      // Créer un nouvel objet patient avec l'ID
      const newPatient = {
        id: patientAuthId,
        ...patientData,
      };

      // Mettre à jour la liste des patients en utilisant le callback pour garantir l'état le plus récent
      setPatients((prevPatients) => [...prevPatients, newPatient]);

      // Vérifier si le médecin est toujours connecté
      if (!auth.currentUser) {
        console.log("Le médecin a été déconnecté, tentative de reconnexion...");
        // Si le médecin a été déconnecté, essayer de le reconnecter
        // Note: Cela nécessiterait de stocker le mot de passe du médecin, ce qui n'est pas recommandé
        // Une meilleure approche serait de rediriger vers la page de connexion
      } else {
        console.log("Le médecin est toujours connecté:", auth.currentUser.uid);
      }

      // Recharger la liste des patients depuis Firestore pour s'assurer qu'elle est à jour
      await reloadPatients();

      setMessage(
        "Patient ajouté avec succès. Un message WhatsApp a été envoyé avec les informations de connexion."
      );
      resetPatientForm();
      setShowPatientForm(false);

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de l'ajout du patient:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour modifier un patient
  const handleEditPatient = async (e) => {
    e.preventDefault();

    if (!selectedPatient) {
      setMessage("Aucun patient sélectionné pour modification");
      return;
    }

    // Vérifier si le patient a été créé par une structure
    if (selectedPatient.createdByStructure) {
      setMessage(
        "Vous ne pouvez pas modifier un patient créé par une structure"
      );
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;

      if (!user) {
        setMessage("Vous n'êtes pas connecté. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      // Vérifier si le patient est privé ou associé à une structure
      if (!patientForm.isPrivate && !patientForm.structureId) {
        setMessage(
          "Veuillez sélectionner une structure ou marquer le patient comme privé"
        );
        setLoading(false);
        return;
      }

      // Données du patient à mettre à jour
      const patientData = {
        ...patientForm,
        updatedAt: new Date(),
      };

      // Mettre à jour le document patient dans Firestore
      await updateDoc(doc(db, "patients", selectedPatient.id), patientData);
      console.log("Document patient mis à jour dans Firestore");

      // Mettre à jour la liste des patients en mémoire
      setPatients((prevPatients) =>
        prevPatients.map((patient) =>
          patient.id === selectedPatient.id
            ? { ...patient, ...patientData }
            : patient
        )
      );

      setMessage("Patient modifié avec succès.");
      resetPatientForm();
      setSelectedPatient(null);
      setShowEditPatientForm(false);

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de la modification du patient:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour supprimer un patient
  const handleDeletePatient = async (patientId) => {
    // Vérifier si le patient a été créé par une structure
    const patient = patients.find((p) => p.id === patientId);
    if (patient && patient.createdByStructure) {
      setMessage(
        "Vous ne pouvez pas supprimer un patient créé par une structure"
      );
      return;
    }

    if (
      !window.confirm(
        "Êtes-vous sûr de vouloir supprimer ce patient ? Cette action est irréversible."
      )
    ) {
      return;
    }

    try {
      setLoading(true);

      // Vérifier si le patient a des rendez-vous
      const patientRdvs = rendezVous.filter(
        (rdv) => rdv.patientId === patientId
      );

      if (patientRdvs.length > 0) {
        // Supprimer d'abord tous les rendez-vous du patient
        for (const rdv of patientRdvs) {
          await deleteDoc(doc(db, "rendezvous", rdv.id));
        }
      }

      // Supprimer le patient de Firestore
      await deleteDoc(doc(db, "patients", patientId));

      // Mettre à jour la liste des patients en mémoire
      setPatients((prevPatients) =>
        prevPatients.filter((patient) => patient.id !== patientId)
      );

      // Mettre à jour la liste des rendez-vous en mémoire
      setRendezVous((prevRdvs) =>
        prevRdvs.filter((rdv) => rdv.patientId !== patientId)
      );

      setMessage("Patient et ses rendez-vous supprimés avec succès.");

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de la suppression du patient:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour basculer le statut privé d'un patient
  const togglePatientPrivacy = async (patient) => {
    // Vérifier si le patient a été créé par une structure
    if (patient.createdByStructure) {
      setMessage(
        "Vous ne pouvez pas modifier un patient créé par une structure"
      );
      return;
    }

    try {
      setLoading(true);

      // Mettre à jour le statut privé dans Firestore
      await updateDoc(doc(db, "patients", patient.id), {
        isPrivate: !patient.isPrivate,
        updatedAt: new Date(),
      });

      // Mettre à jour la liste des patients en mémoire
      setPatients((prevPatients) =>
        prevPatients.map((p) =>
          p.id === patient.id ? { ...p, isPrivate: !p.isPrivate } : p
        )
      );

      setMessage(
        `Patient ${
          patient.isPrivate ? "rendu public" : "rendu privé"
        } avec succès.`
      );

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de la modification du statut privé:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour basculer le statut privé d'un rendez-vous
  const toggleRdvPrivacy = async (rdv) => {
    // Vérifier si le rendez-vous concerne un patient créé par une structure
    const patient = patients.find((p) => p.id === rdv.patientId);
    if (patient && patient.createdByStructure) {
      setMessage(
        "Vous ne pouvez pas rendre privé un rendez-vous pour un patient de structure"
      );
      return;
    }

    try {
      setLoading(true);

      // Mettre à jour le statut privé dans Firestore
      await updateDoc(doc(db, "rendezvous", rdv.id), {
        isPrivate: !rdv.isPrivate,
        updatedAt: new Date(),
      });

      // Mettre à jour la liste des rendez-vous en mémoire
      setRendezVous((prevRdvs) =>
        prevRdvs.map((r) =>
          r.id === rdv.id ? { ...r, isPrivate: !r.isPrivate } : r
        )
      );

      setMessage(
        `Rendez-vous ${
          rdv.isPrivate ? "rendu public" : "rendu privé"
        } avec succès.`
      );

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error(
        "Erreur lors de la modification du statut privé du rendez-vous:",
        error
      );
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour ajouter un rendez-vous
  const handleAddRendezvous = async (e) => {
    e.preventDefault();

    // Vérifier si le patient sélectionné existe
    const selectedPatient = patients.find((p) => p.id === rdvForm.patientId);
    if (!selectedPatient) {
      setMessage("Patient non trouvé");
      return;
    }

    // Si le patient est créé par une structure, le rendez-vous doit être associé à cette structure
    if (selectedPatient.createdByStructure) {
      if (rdvForm.isPrivate) {
        setMessage(
          "Les rendez-vous pour les patients de structure ne peuvent pas être privés"
        );
        return;
      }
      if (rdvForm.structureId !== selectedPatient.structureId) {
        setMessage(
          "Le rendez-vous doit être associé à la structure du patient"
        );
        return;
      }
    }
    // Sinon, vérifier si le rendez-vous est privé ou associé à une structure
    else if (!rdvForm.isPrivate && !rdvForm.structureId) {
      setMessage(
        "Veuillez sélectionner une structure ou marquer le rendez-vous comme privé"
      );
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;

      if (!user) {
        setMessage("Vous n'êtes pas connecté. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      // Récupérer les informations du patient
      const patientDoc = await getDoc(doc(db, "patients", rdvForm.patientId));
      if (!patientDoc.exists()) {
        setMessage("Patient non trouvé");
        setLoading(false);
        return;
      }
      const patientData = patientDoc.data();

      // Ajouter le rendez-vous à Firestore
      const rdvData = {
        ...rdvForm,
        medecinId: user.uid,
        medecinNom: `${medecinData.prenom} ${medecinData.nom}`,
        medecinSpecialite: medecinData.specialite,
        patientNom: `${patientData.prenom} ${patientData.nom}`,
        isPrivate: rdvForm.isPrivate, // S'assurer que le champ isPrivate est inclus
        createdAt: new Date(),
        updatedAt: new Date(),
        patientCreatedByStructure: patientData.createdByStructure || false, // Indiquer si le patient est créé par une structure
      };

      const rdvRef = await addDoc(collection(db, "rendezvous"), rdvData);

      // Ajouter le rendez-vous à la liste en mémoire
      const newRdv = {
        id: rdvRef.id,
        ...rdvData,
      };
      setRendezVous((prevRdvs) => [...prevRdvs, newRdv]);

      // Envoyer une notification au patient par WhatsApp
      if (patientData.telephone) {
        try {
          const phoneNumber = formatPhoneNumberForWhatsApp(
            patientData.telephone
          );
          const rdvMessage =
            `Bonjour ${patientData.prenom},\n\n` +
            `Un rendez-vous a été planifié pour vous avec Dr. ${medecinData.prenom} ${medecinData.nom}.\n\n` +
            `Date: ${new Date(rdvForm.date).toLocaleDateString()}\n` +
            `Heure: ${rdvForm.heure}\n` +
            `Motif: ${rdvForm.motif || "Consultation"}\n\n` +
            `Merci de confirmer votre présence.`;

          await sendWhatsAppMessage(phoneNumber, rdvMessage);
        } catch (whatsappError) {
          console.error(
            "Erreur lors de l'envoi du message WhatsApp:",
            whatsappError
          );
          // Ne pas bloquer la création du rendez-vous si l'envoi du message échoue
        }
      }

      setMessage(
        "Rendez-vous ajouté avec succès. Une notification a été envoyée au patient."
      );
      resetRdvForm();
      setShowRendezvousForm(false);

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de l'ajout du rendez-vous:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour éditer un rendez-vous existant
  const handleEditRendezvous = async (e) => {
    e.preventDefault();

    if (!selectedRdv) {
      setMessage("Aucun rendez-vous sélectionné pour modification");
      return;
    }

    // Vérifier si le patient sélectionné existe
    const selectedPatient = patients.find(
      (p) => p.id === rdvEditForm.patientId
    );
    if (!selectedPatient) {
      setMessage("Patient non trouvé");
      return;
    }

    // Si le patient est créé par une structure, le rendez-vous doit être associé à cette structure
    if (selectedPatient.createdByStructure) {
      if (rdvEditForm.isPrivate) {
        setMessage(
          "Les rendez-vous pour les patients de structure ne peuvent pas être privés"
        );
        return;
      }
      if (rdvEditForm.structureId !== selectedPatient.structureId) {
        setMessage(
          "Le rendez-vous doit être associé à la structure du patient"
        );
        return;
      }
    }
    // Sinon, vérifier si le rendez-vous est privé ou associé à une structure
    else if (!rdvEditForm.isPrivate && !rdvEditForm.structureId) {
      setMessage(
        "Veuillez sélectionner une structure ou marquer le rendez-vous comme privé"
      );
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;

      if (!user) {
        setMessage("Vous n'êtes pas connecté. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      // Récupérer les informations du patient
      const patientDoc = await getDoc(
        doc(db, "patients", rdvEditForm.patientId)
      );
      if (!patientDoc.exists()) {
        setMessage("Patient non trouvé");
        setLoading(false);
        return;
      }
      const patientData = patientDoc.data();

      // Mettre à jour le rendez-vous dans Firestore
      const rdvData = {
        ...rdvEditForm,
        patientNom: `${patientData.prenom} ${patientData.nom}`,
        updatedAt: new Date(),
        patientCreatedByStructure: patientData.createdByStructure || false,
      };

      await updateDoc(doc(db, "rendezvous", selectedRdv.id), rdvData);

      // Mettre à jour la liste des rendez-vous en mémoire
      setRendezVous((prevRdvs) =>
        prevRdvs.map((rdv) =>
          rdv.id === selectedRdv.id ? { ...rdv, ...rdvData } : rdv
        )
      );

      // Envoyer une notification au patient par WhatsApp
      if (patientData.telephone) {
        try {
          const phoneNumber = formatPhoneNumberForWhatsApp(
            patientData.telephone
          );
          const rdvMessage =
            `Bonjour ${patientData.prenom},\n\n` +
            `Votre rendez-vous avec Dr. ${medecinData.prenom} ${medecinData.nom} a été modifié.\n\n` +
            `Nouvelle date: ${new Date(
              rdvEditForm.date
            ).toLocaleDateString()}\n` +
            `Nouvelle heure: ${rdvEditForm.heure}\n` +
            `Motif: ${rdvEditForm.motif || "Consultation"}\n\n` +
            `Merci de confirmer votre présence.`;

          await sendWhatsAppMessage(phoneNumber, rdvMessage);
        } catch (whatsappError) {
          console.error(
            "Erreur lors de l'envoi du message WhatsApp:",
            whatsappError
          );
          // Ne pas bloquer la modification du rendez-vous si l'envoi du message échoue
        }
      }

      setMessage(
        "Rendez-vous modifié avec succès. Une notification a été envoyée au patient."
      );
      resetRdvEditForm();
      setShowEditRdvForm(false);

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de la modification du rendez-vous:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour supprimer un rendez-vous
  const handleDeleteRdv = async (rdvId) => {
    if (
      !window.confirm("Êtes-vous sûr de vouloir supprimer ce rendez-vous ?")
    ) {
      return;
    }

    try {
      setLoading(true);

      // Récupérer les informations du rendez-vous
      const rdvDoc = await getDoc(doc(db, "rendezvous", rdvId));
      if (rdvDoc.exists()) {
        const rdvData = rdvDoc.data();

        // Récupérer les informations du patient
        const patientDoc = await getDoc(doc(db, "patients", rdvData.patientId));
        if (patientDoc.exists()) {
          const patientData = patientDoc.data();

          // Envoyer une notification au patient par WhatsApp
          if (patientData.telephone) {
            try {
              const phoneNumber = formatPhoneNumberForWhatsApp(
                patientData.telephone
              );
              const rdvMessage =
                `Bonjour ${patientData.prenom},\n\n` +
                `Votre rendez-vous du ${new Date(
                  rdvData.date
                ).toLocaleDateString()} à ${rdvData.heure} ` +
                `avec Dr. ${medecinData.prenom} ${medecinData.nom} a été annulé.\n\n` +
                `Veuillez contacter le cabinet pour plus d'informations.`;

              await sendWhatsAppMessage(phoneNumber, rdvMessage);
            } catch (whatsappError) {
              console.error(
                "Erreur lors de l'envoi du message WhatsApp:",
                whatsappError
              );
              // Ne pas bloquer la suppression du rendez-vous si l'envoi du message échoue
            }
          }
        }
      }

      // Supprimer le rendez-vous de Firestore
      await deleteDoc(doc(db, "rendezvous", rdvId));

      // Mettre à jour la liste des rendez-vous en mémoire
      setRendezVous((prevRdvs) => prevRdvs.filter((rdv) => rdv.id !== rdvId));

      setMessage("Rendez-vous supprimé avec succès.");

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Erreur lors de la suppression du rendez-vous:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour éditer un patient existant
  const editPatient = (patient) => {
    // Vérifier si le patient a été créé par une structure
    if (patient.createdByStructure) {
      setMessage(
        "Vous ne pouvez pas modifier un patient créé par une structure"
      );
      return;
    }

    setSelectedPatient(patient);
    setPatientForm({
      nom: patient.nom,
      prenom: patient.prenom,
      dateNaissance: patient.dateNaissance,
      email: patient.email,
      telephone: patient.telephone,
      sexe: patient.sexe || "",
      adresse: patient.adresse || "",
      assurances: patient.assurances || [],
      numeroAssurance: patient.numeroAssurance || "",
      antecedentsMedicaux: patient.antecedentsMedicaux || "",
      structureId: patient.structureId || "",
      isPrivate: patient.isPrivate || false,
    });
    setShowEditPatientForm(true);
    setShowPatientForm(false);
  };

  // Fonction pour éditer un rendez-vous existant
  const editRendezVous = (rdv) => {
    setSelectedRdv(rdv);
    setRdvEditForm({
      patientId: rdv.patientId,
      date: rdv.date,
      heure: rdv.heure,
      duree: rdv.duree,
      motif: rdv.motif || "",
      statut: rdv.statut,
      structureId: rdv.structureId || "",
      isPrivate: rdv.isPrivate || false,
    });
    setShowEditRdvForm(true);
  };

  // Fonction pour vérifier si un patient a des rendez-vous
  const patientHasAppointments = (patientId) => {
    return rendezVous.some((rdv) => rdv.patientId === patientId);
  };

  // Fonction pour calculer l'âge à partir de la date de naissance
  const calculateAge = (dateNaissance) => {
    if (!dateNaissance) return "";

    const birthDate = new Date(dateNaissance);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  // Fonction pour vérifier la disponibilité du médecin
  const checkMedecinDisponibilite = (date, heure) => {
    // Cette fonction devrait vérifier si le médecin est disponible à la date et heure spécifiées
    // Pour l'exemple, on considère que le médecin est toujours disponible
    return true;
  };

  // Fonction pour naviguer dans le calendrier
  const navigateCalendar = (direction) => {
    const newDate = new Date(currentDate);

    if (calendarView === "day") {
      newDate.setDate(newDate.getDate() + (direction === "next" ? 1 : -1));
    } else if (calendarView === "week") {
      newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
    } else if (calendarView === "month") {
      newDate.setMonth(newDate.getMonth() + (direction === "next" ? 1 : -1));
    }

    setCurrentDate(newDate);
  };

  // Fonction pour changer la vue du calendrier
  const changeCalendarView = (view) => {
    setCalendarView(view);
  };

  // Fonction pour obtenir les rendez-vous d'une journée spécifique
  const getAppointmentsForDay = (date) => {
    const dateString = date.toISOString().split("T")[0];
    return rendezVous.filter((rdv) => rdv.date === dateString);
  };

  // Fonction pour obtenir les jours de la semaine en cours
  const getDaysInWeek = () => {
    const days = [];
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay()); // Dimanche comme premier jour

    for (let i = 0; i < 7; i++) {
      const day = new Date(startOfWeek);
      day.setDate(day.getDate() + i);
      days.push(day);
    }

    return days;
  };

  // Fonction pour obtenir les jours du mois en cours
  const getDaysInMonth = () => {
    const days = [];
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    // Premier jour du mois
    const firstDay = new Date(year, month, 1);
    // Dernier jour du mois
    const lastDay = new Date(year, month + 1, 0);

    // Ajouter les jours du mois précédent pour compléter la première semaine
    const firstDayOfWeek = firstDay.getDay(); // 0 = Dimanche, 1 = Lundi, etc.
    for (let i = firstDayOfWeek; i > 0; i--) {
      const prevMonthDay = new Date(year, month, 1 - i);
      days.push(prevMonthDay);
    }

    // Ajouter tous les jours du mois en cours
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push(new Date(year, month, i));
    }

    // Ajouter les jours du mois suivant pour compléter la dernière semaine
    const lastDayOfWeek = lastDay.getDay();
    for (let i = 1; i < 7 - lastDayOfWeek; i++) {
      const nextMonthDay = new Date(year, month + 1, i);
      days.push(nextMonthDay);
    }

    return days;
  };

  // Fonction pour formater l'heure
  const formatTime = (time) => {
    return time;
  };

  // Fonction pour vérifier si deux dates sont le même jour
  const isSameDay = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  // Filtrer les patients en fonction des critères
  const filteredPatients = patients.filter((patient) => {
    // Filtre pour les patients privés
    if (filterPrivate && !patient.isPrivate) return false;

    // Filtre par structure
    if (filterStructure && patient.structureId !== filterStructure)
      return false;

    // Filtre pour les patients ayant des rendez-vous
    if (filterHasAppointment && !patientHasAppointments(patient.id))
      return false;

    // Filtre pour les patients de structure
    if (filterStructurePatients && !patient.createdByStructure) return false;

    return true;
  });

  // Filtrer les rendez-vous pour le calendrier
  const filteredCalendarRdvs = rendezVous.filter((rdv) => {
    // Filtre pour les RDV privés
    if (filterPrivateRdv && !rdv.isPrivate) return false;

    // Filtre par structure
    if (filterCalendarStructure && rdv.structureId !== filterCalendarStructure)
      return false;

    return true;
  });

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-1">
      {/* Affichage des messages */}
      {message && (
        <div
          className={`alert alert-dismissible fade show ${
            message.includes("Erreur") ? "alert-danger" : "alert-success"
          }`}
          role="alert"
        >
          {message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage("")}
          ></button>
        </div>
      )}

      {/* Onglets */}
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "patients" ? "active" : ""}`}
            onClick={() => setActiveTab("patients")}
          >
            <FontAwesomeIcon icon={faUser} className="me-2" />
            Mes patients
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "rendezvous" ? "active" : ""}`}
            onClick={() => setActiveTab("rendezvous")}
          >
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Planifier un rendez-vous
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "calendrier" ? "active" : ""}`}
            onClick={() => setActiveTab("calendrier")}
          >
            <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
            Calendrier des RDV
          </button>
        </li>
        <li className="nav-item ms-auto"></li>
      </ul>

      {/* Onglet Patients */}
      {activeTab === "patients" && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <button
              className="btn btn-primary"
              onClick={() => {
                resetPatientForm();
                setShowPatientForm(!showPatientForm);
                setShowEditPatientForm(false);
              }}
            >
              <FontAwesomeIcon icon={faUserPlus} className="me-2" />
              {showPatientForm ? "Annuler" : "Nouveau patient"}
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() =>
                openWebPopup(
                  "https://sam-patient-hub-connect.lovable.app/auth",
                  "Site externe"
                )
              }
            >
              <FontAwesomeIcon icon={faArrowRight} className="me-2" />
              Dossiers Ophtalmologie
            </button>
          </div>

          {/* Filtres pour les patients */}
          <div className="card shadow-sm mb-4">
            <div className="card-header">
              <h5>
                <FontAwesomeIcon icon={faFilter} className="me-2" />
                Filtres
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3 mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="filterPrivate"
                      checked={filterPrivate}
                      onChange={(e) => setFilterPrivate(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="filterPrivate">
                      <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                      Patients privés uniquement
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="filterHasAppointment"
                      checked={filterHasAppointment}
                      onChange={(e) =>
                        setFilterHasAppointment(e.target.checked)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="filterHasAppointment"
                    >
                      <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />{" "}
                      Avec rendez-vous
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="filterStructurePatients"
                      checked={filterStructurePatients}
                      onChange={(e) =>
                        setFilterStructurePatients(e.target.checked)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="filterStructurePatients"
                    >
                      <FontAwesomeIcon icon={faBuilding} className="me-1" />{" "}
                      Patients de structure
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mb-2">
                  <select
                    className="form-select"
                    value={filterStructure}
                    onChange={(e) => setFilterStructure(e.target.value)}
                  >
                    <option value="">Toutes les structures</option>
                    {affiliatedStructures.map((structure) => (
                      <option key={structure.id} value={structure.id}>
                        {structure.nom}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Formulaire d'ajout de patient */}
          {showPatientForm && (
            <div className="card shadow-sm mb-4">
              <div className="card-header">
                <h5>Ajouter un nouveau patient</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleAddPatient}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="isPrivate"
                          name="isPrivate"
                          checked={patientForm.isPrivate}
                          onChange={handlePatientChange}
                        />
                        <label className="form-check-label" htmlFor="isPrivate">
                          <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                          Patient privé (visible uniquement par vous)
                        </label>
                      </div>
                    </div>
                  </div>

                  {!patientForm.isPrivate && (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Structure</label>
                        <select
                          name="structureId"
                          className="form-select"
                          value={patientForm.structureId}
                          onChange={handlePatientChange}
                          required={!patientForm.isPrivate}
                        >
                          <option value="">Sélectionner une structure</option>
                          {affiliatedStructures.map((structure) => (
                            <option key={structure.id} value={structure.id}>
                              {structure.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Nom</label>
                      <input
                        type="text"
                        name="nom"
                        className="form-control"
                        value={patientForm.nom}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Prénom</label>
                      <input
                        type="text"
                        name="prenom"
                        className="form-control"
                        value={patientForm.prenom}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date de naissance</label>
                      <input
                        type="date"
                        name="dateNaissance"
                        className="form-control"
                        value={patientForm.dateNaissance}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Sexe</label>
                      <select
                        name="sexe"
                        className="form-select"
                        value={patientForm.sexe}
                        onChange={handlePatientChange}
                      >
                        <option value="">Sélectionner</option>
                        <option value="Homme">Homme</option>
                        <option value="Femme">Femme</option>
                        <option value="Autre">Autre</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Téléphone</label>
                      <input
                        type="tel"
                        name="telephone"
                        className="form-control"
                        value={patientForm.telephone}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={patientForm.email}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Adresse</label>
                    <textarea
                      name="adresse"
                      className="form-control"
                      value={patientForm.adresse}
                      onChange={handlePatientChange}
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Assurances</label>
                    <div className="row">
                      {assurancesList.map((assurance) => (
                        <div className="col-md-4 mb-2" key={assurance}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`assurance-${assurance}`}
                              name="assurances"
                              value={assurance}
                              checked={patientForm.assurances.includes(
                                assurance
                              )}
                              onChange={handlePatientChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`assurance-${assurance}`}
                            >
                              {assurance}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Numéro d'assurance</label>
                    <input
                      type="text"
                      name="numeroAssurance"
                      className="form-control"
                      value={patientForm.numeroAssurance}
                      onChange={handlePatientChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Antécédents médicaux</label>
                    <textarea
                      name="antecedentsMedicaux"
                      className="form-control"
                      value={patientForm.antecedentsMedicaux}
                      onChange={handlePatientChange}
                    ></textarea>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => setShowPatientForm(false)}
                    >
                      <FontAwesomeIcon icon={faTimes} className="me-1" />{" "}
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faSave} className="me-1" />{" "}
                      Enregistrer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Formulaire de modification de patient */}
          {showEditPatientForm && selectedPatient && (
            <div className="card shadow-sm mb-4">
              <div className="card-header">
                <h5>Modifier le patient</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleEditPatient}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="isPrivateEdit"
                          name="isPrivate"
                          checked={patientForm.isPrivate}
                          onChange={handlePatientChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isPrivateEdit"
                        >
                          <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                          Patient privé (visible uniquement par vous)
                        </label>
                      </div>
                    </div>
                  </div>

                  {!patientForm.isPrivate && (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Structure</label>
                        <select
                          name="structureId"
                          className="form-select"
                          value={patientForm.structureId}
                          onChange={handlePatientChange}
                          required={!patientForm.isPrivate}
                        >
                          <option value="">Sélectionner une structure</option>
                          {affiliatedStructures.map((structure) => (
                            <option key={structure.id} value={structure.id}>
                              {structure.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Nom</label>
                      <input
                        type="text"
                        name="nom"
                        className="form-control"
                        value={patientForm.nom}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Prénom</label>
                      <input
                        type="text"
                        name="prenom"
                        className="form-control"
                        value={patientForm.prenom}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date de naissance</label>
                      <input
                        type="date"
                        name="dateNaissance"
                        className="form-control"
                        value={patientForm.dateNaissance}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Sexe</label>
                      <select
                        name="sexe"
                        className="form-select"
                        value={patientForm.sexe}
                        onChange={handlePatientChange}
                      >
                        <option value="">Sélectionner</option>
                        <option value="Homme">Homme</option>
                        <option value="Femme">Femme</option>
                        <option value="Autre">Autre</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Téléphone</label>
                      <input
                        type="tel"
                        name="telephone"
                        className="form-control"
                        value={patientForm.telephone}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={patientForm.email}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Adresse</label>
                    <textarea
                      name="adresse"
                      className="form-control"
                      value={patientForm.adresse}
                      onChange={handlePatientChange}
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Assurances</label>
                    <div className="row">
                      {assurancesList.map((assurance) => (
                        <div className="col-md-4 mb-2" key={assurance}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`assurance-edit-${assurance}`}
                              name="assurances"
                              value={assurance}
                              checked={patientForm.assurances.includes(
                                assurance
                              )}
                              onChange={handlePatientChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`assurance-edit-${assurance}`}
                            >
                              {assurance}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Numéro d'assurance</label>
                    <input
                      type="text"
                      name="numeroAssurance"
                      className="form-control"
                      value={patientForm.numeroAssurance}
                      onChange={handlePatientChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Antécédents médicaux</label>
                    <textarea
                      name="antecedentsMedicaux"
                      className="form-control"
                      value={patientForm.antecedentsMedicaux}
                      onChange={handlePatientChange}
                    ></textarea>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => setShowEditPatientForm(false)}
                    >
                      <FontAwesomeIcon icon={faTimes} className="me-1" />{" "}
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faSave} className="me-1" />{" "}
                      Enregistrer les modifications
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Liste des patients */}
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>Prénom</th>
                      <th>Âge</th>
                      <th>Téléphone</th>
                      <th>Email</th>
                      <th>Structure</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPatients.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center">
                          Aucun patient trouvé
                        </td>
                      </tr>
                    ) : (
                      filteredPatients.map((patient) => (
                        <tr
                          key={patient.id}
                          className={patient.isPrivate ? "table-light" : ""}
                        >
                          <td>{patient.nom}</td>
                          <td>{patient.prenom}</td>
                          <td>{calculateAge(patient.dateNaissance)} ans</td>
                          <td>
                            <a
                              href={`tel:${patient.telephone}`}
                              className="text-decoration-none"
                            >
                              <FontAwesomeIcon
                                icon={faPhone}
                                className="me-1"
                              />
                              {patient.telephone}
                            </a>
                          </td>
                          <td>
                            <a
                              href={`mailto:${patient.email}`}
                              className="text-decoration-none"
                            >
                              <FontAwesomeIcon
                                icon={faEnvelope}
                                className="me-1"
                              />
                              {patient.email}
                            </a>
                          </td>
                          <td>
                            {patient.createdByStructure ? (
                              <span className="badge bg-info">
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  className="me-1"
                                />
                                {patient.structureName || "Structure"}
                              </span>
                            ) : patient.structureId ? (
                              <span className="badge bg-secondary">
                                {affiliatedStructures.find(
                                  (s) => s.id === patient.structureId
                                )?.nom || "Structure"}
                              </span>
                            ) : (
                              <span className="badge bg-warning text-dark">
                                <FontAwesomeIcon
                                  icon={faLock}
                                  className="me-1"
                                />
                                Privé
                              </span>
                            )}
                          </td>
                          <td>
                            <div className="btn-group">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                  setRdvForm({
                                    ...rdvForm,
                                    patientId: patient.id,
                                    structureId: patient.structureId || "",
                                    isPrivate: patient.isPrivate || false,
                                  });
                                  setActiveTab("rendezvous");
                                  setShowRendezvousForm(true);
                                }}
                                title="Planifier un rendez-vous"
                              >
                                <FontAwesomeIcon icon={faCalendarPlus} />
                              </button>

                              {!patient.createdByStructure && (
                                <>
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => editPatient(patient)}
                                    title="Modifier"
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </button>

                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() =>
                                      handleDeletePatient(patient.id)
                                    }
                                    title="Supprimer"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>

                                  <button
                                    className={`btn btn-sm ${
                                      patient.isPrivate
                                        ? "btn-outline-success"
                                        : "btn-outline-warning"
                                    }`}
                                    onClick={() =>
                                      togglePatientPrivacy(patient)
                                    }
                                    title={
                                      patient.isPrivate
                                        ? "Rendre public"
                                        : "Rendre privé"
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={
                                        patient.isPrivate ? faUnlock : faLock
                                      }
                                    />
                                  </button>
                                </>
                              )}

                              <button
                                className="btn btn-sm btn-outline-info"
                                onClick={() => {
                                  // Afficher l'historique des rendez-vous du patient
                                  const patientRdvs = rendezVous.filter(
                                    (rdv) => rdv.patientId === patient.id
                                  );
                                  console.log(
                                    "Rendez-vous du patient:",
                                    patientRdvs
                                  );
                                  // TODO: Implémenter l'affichage de l'historique
                                }}
                                title="Historique des rendez-vous"
                              >
                                <FontAwesomeIcon icon={faHistory} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Onglet Rendez-vous */}
      {activeTab === "rendezvous" && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3>Planifier un rendez-vous</h3>
            <button
              className="btn btn-primary"
              onClick={() => {
                resetRdvForm();
                setShowRendezvousForm(!showRendezvousForm);
              }}
            >
              <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
              {showRendezvousForm ? "Annuler" : "Nouveau rendez-vous"}
            </button>
          </div>

          {/* Formulaire de rendez-vous */}
          {showRendezvousForm && (
            <div className="card shadow-sm mb-4">
              <div className="card-header">
                <h5>Nouveau rendez-vous</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleAddRendezvous}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Patient</label>
                      <select
                        name="patientId"
                        className="form-select"
                        value={rdvForm.patientId}
                        onChange={handleRdvChange}
                        required
                      >
                        <option value="">Sélectionner un patient</option>
                        {patients.map((patient) => (
                          <option key={patient.id} value={patient.id}>
                            {patient.nom} {patient.prenom}{" "}
                            {patient.isPrivate ? "(Privé)" : ""}
                            {patient.createdByStructure
                              ? ` (${patient.structureName || "Structure"})`
                              : ""}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="form-check mt-4">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="isPrivateRdv"
                          name="isPrivate"
                          checked={rdvForm.isPrivate}
                          onChange={handleRdvChange}
                          disabled={
                            rdvForm.patientId &&
                            patients.find((p) => p.id === rdvForm.patientId)
                              ?.createdByStructure
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isPrivateRdv"
                        >
                          <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                          Rendez-vous privé (visible uniquement par vous)
                        </label>
                      </div>
                    </div>
                  </div>

                  {!rdvForm.isPrivate && (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Structure</label>
                        <select
                          name="structureId"
                          className="form-select"
                          value={rdvForm.structureId}
                          onChange={handleRdvChange}
                          required={!rdvForm.isPrivate}
                          disabled={
                            rdvForm.patientId &&
                            patients.find((p) => p.id === rdvForm.patientId)
                              ?.createdByStructure
                          }
                        >
                          <option value="">Sélectionner une structure</option>
                          {affiliatedStructures.map((structure) => (
                            <option key={structure.id} value={structure.id}>
                              {structure.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        value={rdvForm.date}
                        onChange={handleRdvChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Heure</label>
                      <input
                        type="time"
                        name="heure"
                        className="form-control"
                        value={rdvForm.heure}
                        onChange={handleRdvChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Durée (minutes)</label>
                      <select
                        name="duree"
                        className="form-select"
                        value={rdvForm.duree}
                        onChange={handleRdvChange}
                        required
                      >
                        <option value="15">15 minutes</option>
                        <option value="30">30 minutes</option>
                        <option value="45">45 minutes</option>
                        <option value="60">1 heure</option>
                        <option value="90">1 heure 30</option>
                        <option value="120">2 heures</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Motif</label>
                    <textarea
                      name="motif"
                      className="form-control"
                      value={rdvForm.motif}
                      onChange={handleRdvChange}
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Statut</label>
                    <select
                      name="statut"
                      className="form-select"
                      value={rdvForm.statut}
                      onChange={handleRdvChange}
                    >
                      <option value="confirmé">Confirmé</option>
                      <option value="en attente">En attente</option>
                      <option value="annulé">Annulé</option>
                    </select>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => setShowRendezvousForm(false)}
                    >
                      <FontAwesomeIcon icon={faTimes} className="me-1" />{" "}
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faSave} className="me-1" />{" "}
                      Enregistrer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Liste des rendez-vous récents */}
          <div className="card shadow-sm">
            <div className="card-header">
              <h5>Rendez-vous récents</h5>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Patient</th>
                      <th>Date</th>
                      <th>Heure</th>
                      <th>Durée</th>
                      <th>Motif</th>
                      <th>Statut</th>
                      <th>Structure</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rendezVous.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">
                          Aucun rendez-vous trouvé
                        </td>
                      </tr>
                    ) : (
                      rendezVous
                        .sort(
                          (a, b) =>
                            new Date(a.date + "T" + a.heure) -
                            new Date(b.date + "T" + b.heure)
                        )
                        .filter(
                          (rdv) =>
                            new Date(rdv.date + "T" + rdv.heure) >= new Date()
                        )
                        .slice(0, 10)
                        .map((rdv) => {
                          const patient = patients.find(
                            (p) => p.id === rdv.patientId
                          );
                          return (
                            <tr
                              key={rdv.id}
                              className={rdv.isPrivate ? "table-light" : ""}
                            >
                              <td>
                                {rdv.patientNom ||
                                  (patient
                                    ? `${patient.prenom} ${patient.nom}`
                                    : "Patient inconnu")}
                              </td>
                              <td>{new Date(rdv.date).toLocaleDateString()}</td>
                              <td>{rdv.heure}</td>
                              <td>{rdv.duree} min</td>
                              <td>{rdv.motif || "-"}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    rdv.statut === "confirmé"
                                      ? "bg-success"
                                      : rdv.statut === "en attente"
                                      ? "bg-warning text-dark"
                                      : "bg-danger"
                                  }`}
                                >
                                  {rdv.statut}
                                </span>
                              </td>
                              <td>
                                {rdv.isPrivate ? (
                                  <span className="badge bg-warning text-dark">
                                    <FontAwesomeIcon
                                      icon={faLock}
                                      className="me-1"
                                    />
                                    Privé
                                  </span>
                                ) : rdv.structureId ? (
                                  <span className="badge bg-secondary">
                                    {affiliatedStructures.find(
                                      (s) => s.id === rdv.structureId
                                    )?.nom || "Structure"}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                <div className="btn-group">
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => editRendezVous(rdv)}
                                    title="Modifier"
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </button>

                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteRdv(rdv.id)}
                                    title="Supprimer"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>

                                  {!rdv.patientCreatedByStructure && (
                                    <button
                                      className={`btn btn-sm ${
                                        rdv.isPrivate
                                          ? "btn-outline-success"
                                          : "btn-outline-warning"
                                      }`}
                                      onClick={() => toggleRdvPrivacy(rdv)}
                                      title={
                                        rdv.isPrivate
                                          ? "Rendre public"
                                          : "Rendre privé"
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={rdv.isPrivate ? faUnlock : faLock}
                                      />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Onglet Calendrier */}
      {activeTab === "calendrier" && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3>Calendrier des rendez-vous</h3>
            <div className="btn-group">
              <button
                className={`btn ${
                  calendarView === "day" ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => changeCalendarView("day")}
              >
                <FontAwesomeIcon icon={faCalendarDay} className="me-1" /> Jour
              </button>
              <button
                className={`btn ${
                  calendarView === "week"
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => changeCalendarView("week")}
              >
                <FontAwesomeIcon icon={faCalendarWeek} className="me-1" />{" "}
                Semaine
              </button>
              <button
                className={`btn ${
                  calendarView === "month"
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => changeCalendarView("month")}
              >
                <FontAwesomeIcon icon={faCalendarPlus} className="me-1" /> Mois
              </button>
            </div>
          </div>

          {/* Filtres pour le calendrier */}
          <div className="card shadow-sm mb-4">
            <div className="card-header">
              <h5>
                <FontAwesomeIcon icon={faFilter} className="me-2" />
                Filtres
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3 mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="filterPrivateRdv"
                      checked={filterPrivateRdv}
                      onChange={(e) => setFilterPrivateRdv(e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="filterPrivateRdv"
                    >
                      <FontAwesomeIcon icon={faLock} className="me-1" /> RDV
                      privés uniquement
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mb-2">
                  <select
                    className="form-select"
                    value={filterCalendarStructure}
                    onChange={(e) => setFilterCalendarStructure(e.target.value)}
                  >
                    <option value="">Toutes les structures</option>
                    {affiliatedStructures.map((structure) => (
                      <option key={structure.id} value={structure.id}>
                        {structure.nom}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation du calendrier */}
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigateCalendar("prev")}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>

                <h4 className="m-0">
                  {calendarView === "day" &&
                    currentDate.toLocaleDateString("fr-FR", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  {calendarView === "week" && (
                    <>
                      Semaine du{" "}
                      {getDaysInWeek()[0].toLocaleDateString("fr-FR", {
                        day: "numeric",
                        month: "long",
                      })}
                      au{" "}
                      {getDaysInWeek()[6].toLocaleDateString("fr-FR", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </>
                  )}
                  {calendarView === "month" &&
                    currentDate.toLocaleDateString("fr-FR", {
                      month: "long",
                      year: "numeric",
                    })}
                </h4>

                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigateCalendar("next")}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
          </div>

          {/* Vue du calendrier */}
          <div className="card shadow-sm">
            <div className="card-body">
              {/* Vue journalière */}
              {calendarView === "day" && (
                <div className="day-view">
                  <h5 className="mb-3">
                    {currentDate.toLocaleDateString("fr-FR", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                    })}
                  </h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Heure</th>
                          <th>Rendez-vous</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: 14 }, (_, i) => {
                          const hour = 8 + i;
                          const timeString = `${hour
                            .toString()
                            .padStart(2, "0")}:00`;

                          // Filtrer les rendez-vous pour cette heure
                          const dayRdvs = filteredCalendarRdvs.filter((rdv) => {
                            return (
                              rdv.date ===
                                currentDate.toISOString().split("T")[0] &&
                              rdv.heure.startsWith(
                                hour.toString().padStart(2, "0")
                              )
                            );
                          });

                          return (
                            <tr key={hour}>
                              <td
                                className="text-center"
                                style={{ width: "100px" }}
                              >
                                {timeString}
                              </td>
                              <td>
                                {dayRdvs.length === 0 ? (
                                  <div className="text-muted">Disponible</div>
                                ) : (
                                  dayRdvs.map((rdv) => {
                                    const patient = patients.find(
                                      (p) => p.id === rdv.patientId
                                    );
                                    return (
                                      <div
                                        key={rdv.id}
                                        className={`p-2 mb-1 rounded ${
                                          rdv.statut === "confirmé"
                                            ? "bg-success text-white"
                                            : rdv.statut === "en attente"
                                            ? "bg-warning"
                                            : "bg-danger text-white"
                                        }`}
                                      >
                                        <div className="d-flex justify-content-between">
                                          <span>
                                            <strong>{rdv.heure}</strong> -{" "}
                                            {rdv.patientNom ||
                                              (patient
                                                ? `${patient.prenom} ${patient.nom}`
                                                : "Patient inconnu")}
                                          </span>
                                          <div>
                                            <button
                                              className="btn btn-sm btn-light me-1"
                                              onClick={() =>
                                                editRendezVous(rdv)
                                              }
                                              title="Modifier"
                                            >
                                              <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                              className="btn btn-sm btn-light"
                                              onClick={() =>
                                                handleDeleteRdv(rdv.id)
                                              }
                                              title="Supprimer"
                                            >
                                              <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                          </div>
                                        </div>
                                        <div>{rdv.motif || "Consultation"}</div>
                                        <div className="small">
                                          {rdv.duree} min
                                          {rdv.isPrivate && (
                                            <span className="ms-2 badge bg-secondary">
                                              <FontAwesomeIcon icon={faLock} />{" "}
                                              Privé
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Vue hebdomadaire */}
              {calendarView === "week" && (
                <div className="week-view">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Heure</th>
                          {getDaysInWeek().map((day, index) => (
                            <th
                              key={index}
                              className={
                                isSameDay(day, new Date())
                                  ? "table-primary"
                                  : ""
                              }
                            >
                              {day.toLocaleDateString("fr-FR", {
                                weekday: "short",
                                day: "numeric",
                              })}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: 14 }, (_, i) => {
                          const hour = 8 + i;
                          const timeString = `${hour
                            .toString()
                            .padStart(2, "0")}:00`;

                          return (
                            <tr key={hour}>
                              <td
                                className="text-center"
                                style={{ width: "80px" }}
                              >
                                {timeString}
                              </td>
                              {getDaysInWeek().map((day, dayIndex) => {
                                // Filtrer les rendez-vous pour ce jour et cette heure
                                const dayRdvs = filteredCalendarRdvs.filter(
                                  (rdv) => {
                                    return (
                                      rdv.date ===
                                        day.toISOString().split("T")[0] &&
                                      rdv.heure.startsWith(
                                        hour.toString().padStart(2, "0")
                                      )
                                    );
                                  }
                                );

                                return (
                                  <td
                                    key={dayIndex}
                                    className={
                                      isSameDay(day, new Date())
                                        ? "table-light"
                                        : ""
                                    }
                                  >
                                    {dayRdvs.length === 0 ? (
                                      <div className="text-muted small">-</div>
                                    ) : (
                                      dayRdvs.map((rdv) => {
                                        const patient = patients.find(
                                          (p) => p.id === rdv.patientId
                                        );
                                        return (
                                          <div
                                            key={rdv.id}
                                            className={`p-1 mb-1 rounded small ${
                                              rdv.statut === "confirmé"
                                                ? "bg-success text-white"
                                                : rdv.statut === "en attente"
                                                ? "bg-warning"
                                                : "bg-danger text-white"
                                            }`}
                                          >
                                            <div className="d-flex justify-content-between">
                                              <span>
                                                <strong>{rdv.heure}</strong>
                                              </span>
                                              <div>
                                                <button
                                                  className="btn btn-sm btn-light me-1 py-0 px-1"
                                                  onClick={() =>
                                                    editRendezVous(rdv)
                                                  }
                                                  title="Modifier"
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faEdit}
                                                    size="xs"
                                                  />
                                                </button>
                                              </div>
                                            </div>
                                            <div>
                                              {rdv.patientNom ||
                                                (patient
                                                  ? `${patient.prenom} ${patient.nom}`
                                                  : "Patient inconnu")}
                                            </div>
                                            {rdv.isPrivate && (
                                              <span className="badge bg-secondary">
                                                <FontAwesomeIcon
                                                  icon={faLock}
                                                  size="xs"
                                                />
                                              </span>
                                            )}
                                          </div>
                                        );
                                      })
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Vue mensuelle */}
              {calendarView === "month" && (
                <div className="month-view">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Dim</th>
                          <th>Lun</th>
                          <th>Mar</th>
                          <th>Mer</th>
                          <th>Jeu</th>
                          <th>Ven</th>
                          <th>Sam</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from(
                          { length: Math.ceil(getDaysInMonth().length / 7) },
                          (_, weekIndex) => {
                            const weekDays = getDaysInMonth().slice(
                              weekIndex * 7,
                              (weekIndex + 1) * 7
                            );

                            return (
                              <tr key={weekIndex} style={{ height: "120px" }}>
                                {weekDays.map((day, dayIndex) => {
                                  // Filtrer les rendez-vous pour ce jour
                                  const dayRdvs = filteredCalendarRdvs.filter(
                                    (rdv) =>
                                      rdv.date ===
                                      day.toISOString().split("T")[0]
                                  );

                                  // Vérifier si le jour fait partie du mois en cours
                                  const isCurrentMonth =
                                    day.getMonth() === currentDate.getMonth();

                                  return (
                                    <td
                                      key={dayIndex}
                                      className={`${
                                        isCurrentMonth
                                          ? ""
                                          : "bg-light text-muted"
                                      } ${
                                        isSameDay(day, new Date())
                                          ? "table-primary"
                                          : ""
                                      }`}
                                      style={{
                                        width: "14.28%",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      <div className="d-flex justify-content-between mb-1">
                                        <span
                                          className={`badge ${
                                            isCurrentMonth
                                              ? "bg-secondary"
                                              : "bg-light text-muted"
                                          }`}
                                        >
                                          {day.getDate()}
                                        </span>
                                        {dayRdvs.length > 0 && (
                                          <span className="badge bg-primary">
                                            {dayRdvs.length}
                                          </span>
                                        )}
                                      </div>

                                      <div
                                        style={{
                                          maxHeight: "80px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {dayRdvs.slice(0, 3).map((rdv) => (
                                          <div
                                            key={rdv.id}
                                            className={`p-1 mb-1 rounded small ${
                                              rdv.statut === "confirmé"
                                                ? "bg-success text-white"
                                                : rdv.statut === "en attente"
                                                ? "bg-warning"
                                                : "bg-danger text-white"
                                            }`}
                                            onClick={() => editRendezVous(rdv)}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div>
                                              <strong>{rdv.heure}</strong>{" "}
                                              {rdv.patientNom?.split(" ")[0]}
                                            </div>
                                          </div>
                                        ))}
                                        {dayRdvs.length > 3 && (
                                          <div className="text-center small">
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setCurrentDate(day);
                                                changeCalendarView("day");
                                              }}
                                            >
                                              +{dayRdvs.length - 3} autres
                                            </a>
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Formulaire d'édition de rendez-vous */}
      {showEditRdvForm && selectedRdv && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Modifier le rendez-vous</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowEditRdvForm(false);
                    resetRdvEditForm();
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditRendezvous}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Patient</label>
                      <select
                        name="patientId"
                        className="form-select"
                        value={rdvEditForm.patientId}
                        onChange={handleRdvEditChange}
                        required
                      >
                        <option value="">Sélectionner un patient</option>
                        {patients.map((patient) => (
                          <option key={patient.id} value={patient.id}>
                            {patient.nom} {patient.prenom}{" "}
                            {patient.isPrivate ? "(Privé)" : ""}
                            {patient.createdByStructure
                              ? ` (${patient.structureName || "Structure"})`
                              : ""}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="form-check mt-4">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="isPrivateRdvEdit"
                          name="isPrivate"
                          checked={rdvEditForm.isPrivate}
                          onChange={handleRdvEditChange}
                          disabled={
                            rdvEditForm.patientId &&
                            patients.find((p) => p.id === rdvEditForm.patientId)
                              ?.createdByStructure
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isPrivateRdvEdit"
                        >
                          <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                          Rendez-vous privé (visible uniquement par vous)
                        </label>
                      </div>
                    </div>
                  </div>

                  {!rdvEditForm.isPrivate && (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Structure</label>
                        <select
                          name="structureId"
                          className="form-select"
                          value={rdvEditForm.structureId}
                          onChange={handleRdvEditChange}
                          required={!rdvEditForm.isPrivate}
                          disabled={
                            rdvEditForm.patientId &&
                            patients.find((p) => p.id === rdvEditForm.patientId)
                              ?.createdByStructure
                          }
                        >
                          <option value="">Sélectionner une structure</option>
                          {affiliatedStructures.map((structure) => (
                            <option key={structure.id} value={structure.id}>
                              {structure.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        value={rdvEditForm.date}
                        onChange={handleRdvEditChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Heure</label>
                      <input
                        type="time"
                        name="heure"
                        className="form-control"
                        value={rdvEditForm.heure}
                        onChange={handleRdvEditChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Durée (minutes)</label>
                      <select
                        name="duree"
                        className="form-select"
                        value={rdvEditForm.duree}
                        onChange={handleRdvEditChange}
                        required
                      >
                        <option value="15">15 minutes</option>
                        <option value="30">30 minutes</option>
                        <option value="45">45 minutes</option>
                        <option value="60">1 heure</option>
                        <option value="90">1 heure 30</option>
                        <option value="120">2 heures</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Motif</label>
                    <textarea
                      name="motif"
                      className="form-control"
                      value={rdvEditForm.motif}
                      onChange={handleRdvEditChange}
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Statut</label>
                    <select
                      name="statut"
                      className="form-select"
                      value={rdvEditForm.statut}
                      onChange={handleRdvEditChange}
                    >
                      <option value="confirmé">Confirmé</option>
                      <option value="en attente">En attente</option>
                      <option value="annulé">Annulé</option>
                    </select>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowEditRdvForm(false);
                    resetRdvEditForm();
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} className="me-1" /> Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleEditRendezvous}
                >
                  <FontAwesomeIcon icon={faSave} className="me-1" /> Enregistrer
                  les modifications
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Popup pour afficher une page web */}
      {showWebPopup && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{webPopupTitle}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowWebPopup(false)}
                ></button>
              </div>
              <div
                className="modal-body p-0"
                style={{ height: "100vh", width: "100%" }}
              >
                <iframe
                  src={webPopupUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    borderRadius: "0 0 0.3rem 0.3rem",
                  }}
                  title={webPopupTitle}
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MedecinPatientManager;
